import styled from 'styled-components';

import { Modal } from 'shared/components/modal/Modals';

import { colors, fonts, fontSizes, device } from 'shared/defaultTheme';

const CustomFolderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  min-height: 490px;
`;

const ActionBarWrapper = styled.div`
  width: 100%;
  .add-button {
    background-color: transparent;
    border: none !important;
    box-shadow: none !important;
    color: ${colors.black};
    font-size: ${fontSizes.xs}px;
    height: 17px;
    flex-direction: row-reverse;
    justify-content: space-between;
    align-items: center;
    margin-right: 17px;
    text-transform: uppercase;
    width: 135px;
    &.subfolder {
      width: 155px;
    }
    span {
      margin-top: 5px;
    }
    .button__icon-wrapper {
      margin-right: 0 !important;
      svg {
        fill: ${colors.black};
        height: 15px;
        width: 15px;
      }
    }
  }

  @media ${device.sm} {
    .container-actions {
      display: block;
      justify-content: space-between;
    }
  }
  @media ${device.md} {
    .container-actions {
      display: flex;
      justify-content: space-between;
    }
  }
  @media ${device.lg} {
    .container-actions {
      display: flex;
      justify-content: space-between;
    }
  }
  @media ${device.xl} {
    .container-actions {
      display: flex;
      justify-content: space-between;
    }
  }
`;

const EmptyWrapper = styled.div`
  flex: 0.9;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  svg {
    fill: ${colors.suvaGrey};
    height: 59px;
    width: 73px;
    margin-bottom: 10px;
  }
  span {
    color: ${colors.suvaGrey};
    font-family: ${fonts.default};
    font-size: ${fontSizes.sm}px;
    font-weight: 500;
    line-height: 16px;
  }
`;

const CustomModalWrapper = styled(Modal)`
  top: 15%;
  &.translate-modal {
    top: 10%;
    max-width: 930px;
    .row {
      width: 100% !important;
    }
    .translate-icon {
      height: 26px;
      width: 26px;
    }
    select {
      border: none;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.5);
      background-size: 15px;
      height: 24px;
      min-width: 159px;
    }
  }
  .modal-content {
    border-radius: 4px;
  }
  .modal-header {
    border: 0;
    height: 36px;
    padding-top: 20px;
    padding-bottom: 0;

    svg {
      fill: ${colors.suvaGrey} !important;
      height: 18px !important;
      width: 18px !important;
    }
    .div-icon-wrapper {
      width: 26%;
      height: 35px;
    }
  }
  .modal-body {
    padding-left: 30px;
    padding-right: 30px;
    padding: 0 28px;
    padding-bottom: 26px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .row-title {
    border-bottom: 1px solid ${colors.spanishGray};
    padding: 0;
    padding-bottom: 17px;
    margin-bottom: 10px;
    width: 100%;

    h3 {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: ${fontSizes.xlg}px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 24px;
    }
    .col-sm-12 {
      padding-left: 0;
    }
  }
`;

const CustomFoldersDataWrapper = styled.div`
  border-top: 1px solid ${colors.pattens};
  display: flex;
  flex: 0.9;
  flex-direction: column;
  margin-top: 16px;
  overflow-y: auto;
  width: 100%;
`;

const TranslateLabel = styled.span`
  color: ${({ color }) => color};
  font-family: ${fonts.default};
  font-size: ${fontSizes.sm}px;
  font-weight: bold;
  line-height: 16px;
`;

const CustomFolderTreeWrapper = styled.div`
  border: none;
  border-bottom: 1px solid ${colors.lightSilver};
  border-top: 1px solid ${colors.lightSilver};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: ${({ level }) => 5 * level + 5}px;
  width: 100%;
  .info-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
    .folder-icon {
      height: 15px;
      width: 15px;
      fill: ${colors.black};
    }
    span {
      color: ${colors.black};
      font-family: ${fonts.default};
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
      line-height: 16px;
    }

    .text-file {
      padding-left: 5px;
    }

    .text-folder {
      margin-top: 5px;
      margin-left: 6px;
    }
  }
  .form-check-input {
    position: initial;
    margin-top: 0;
    margin-left: 0;
  }
  .caret {
    fill: ${colors.black};
    height: 16px;
    width: 16px;
    padding-left: 4px;
  }

  .actions {
    display: flex;
    flex-direction: row;
    align-items: center;
    button {
      background-color: transparent;
      border: none;
      :active {
        opacity: 0.5;
      }
    }
    svg {
      height: 21px;
      width: 17px;
      fill: ${colors.suvaGrey};
    }
  }
`;

export {
  CustomFolderWrapper,
  ActionBarWrapper,
  EmptyWrapper,
  CustomModalWrapper,
  CustomFoldersDataWrapper,
  TranslateLabel,
  CustomFolderTreeWrapper,
};
